import styled from 'styled-components';
import { Colors } from '@/common/colors/colors';

export const FormBody = styled.div`
	display: flex;
	flex-direction: column;
	min-width: 560px;
	min-height: 280px;
`;

export const Title = styled.h3`
	margin: 0 0 16px;
	color: ${Colors.darkBlue};
`;

export const SaveRow = styled.div`
	display: flex;
	justify-content: flex-end;
	margin-top: auto;
	padding-top: 24px;
`;
